import React from 'react'
import PreloaderIcon from 'react-preloader-icon'
import TailSpin from 'react-preloader-icon/loaders/TailSpin'
import styled from 'styled-components'

const PreloaderSoildOverlay = styled.div`
  z-index: 450;
  position: absolute;
  width: 100%;
  height: 100%;
`

const PreloaderBackground = styled.div`
  position: absolute;
  width: 200px;
  height: 200px;
  top: 10px;
  left: 50%;
  border-radius: 30px;
  transform: translateX(-50%);
  background-color: rgba(0, 0, 0, 0.2);
  z-index: 500;
`

const PreloaderWrapper = styled.div`
  width: 60px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`

export default () => (
  <PreloaderSoildOverlay>
    {/* <PreloaderBackground>
      <PreloaderWrapper>
        <PreloaderIcon
          loader={TailSpin}
          size={60}
          strokeWidth={8}
          strokeColor="#38a4d7"
          duration={800}
          className="interactionPreloader"
        />
      </PreloaderWrapper>
    </PreloaderBackground> */}
  </PreloaderSoildOverlay>
)
